import { DownOutlined, LockOutlined, LogoutOutlined, UserOutlined } from "@ant-design/icons";
import { Avatar, Dropdown } from "antd";
import React, { useCallback, useEffect } from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import useAuth from "../hooks/useAuth";
import { generateInitialFromName } from "../helpers/generator";
import { generateFullName } from "../helpers/text";

const UserAvatar: React.FC = () => {
	const history = useHistory();
	const { user, logout, isLoggedIn, isLoading } = useAuth();
	const name = generateFullName({
		firstName: user.firstName ?? "",
		middleName: user.middleName ?? "",
		lastName: user.lastName ?? "",
	});
	const initial = generateInitialFromName(name);
	const handleMenuClick = useCallback(
		(e: any) => {
			if (e.key === "profile") {
				history.push({ pathname: "/profile" });
			} else if (e.key === "change-password") {
				history.push({ pathname: "/change-password" });
			} else {
				logout();
			}
		},
		[history, logout]
	);

	useEffect(() => {
		if (!isLoggedIn && !isLoading) {
			history.replace({ pathname: "/login" });
		}
	}, [history, isLoading, isLoggedIn]);

	return (
		<Dropdown
			trigger={["click"]}
			menu={{
				onClick: handleMenuClick,
				items: [
					{
						type: "group",
						label: "Welcome, " + (name!.length > 15 ? name!.substring(0, 15) + "..." : name),
						children: [
							{
								type: "divider",
							},
							{
								key: "profile",
								icon: <UserOutlined />,
								label: "My Profile",
							},
							{
								key: "change-password",
								icon: <LockOutlined />,
								label: "Change Password",
							},
							{
								key: "logout",
								icon: <LogoutOutlined />,
								label: "Logout",
							},
						],
					},
				],
			}}
		>
			<div>
				<AppAvatar size="large">{initial?.toUpperCase()}</AppAvatar>
				<Icon />
			</div>
		</Dropdown>
	);
};

const AppAvatar = styled(Avatar)`
	background-color: ${({ theme }) => theme.colors.ash500};
	color: ${({ theme }) => theme.colors.black};
	margin-right: 10px;
`;

const Icon = styled(DownOutlined)`
	color: ${({ theme }) => theme.colors.white};
`;

export default UserAvatar;
